import { map, isArray, isObject, isPlainObject, mapValues } from 'lodash';

function mapValuesDeep(obj: any, fn: (x: any) => any): any {
  return isArray(obj)
    ? map(obj, (innerObj) => mapValuesDeep(innerObj, fn))
    : isPlainObject(obj)
    ? mapValues(obj, (val) => mapValuesDeep(val, fn))
    : isObject(obj)
    ? obj
    : fn(obj);
}

export default mapValuesDeep;
